import {createSlice} from '@reduxjs/toolkit';
import { getLegacyEmpresas } from '../legacy/thunk.js';

export const initialState = {
    legacyEmpresas: [],
    error: {},
};

const legacyEmpresasSlice = createSlice({
    name: 'legacyEmpresas',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyEmpresas.fulfilled, (state, action) => {
            state.legacyEmpresas = action.payload;
        });
        builder.addCase(getLegacyEmpresas.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default legacyEmpresasSlice.reducer;